import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeftRight, Mail, ArrowLeft, CheckCircle2, AlertCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (BACKEND_URL && !BACKEND_URL.startsWith("http")) {
  BACKEND_URL = `https://${BACKEND_URL}`;
}
if (!BACKEND_URL) {
  BACKEND_URL = window.location.origin;
}
const API = `${BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-indigo-600">
            <ArrowLeftRight className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-slate-900 text-xl tracking-tight">Field Sync</h1>
            <p className="text-sm text-slate-500">HubSpot &#8596; Business Central</p>
          </div>
        </div>

        <Card>
          <CardHeader className="text-center">
            <CardTitle>Mot de passe oublié</CardTitle>
            <CardDescription>
              Entrez votre courriel pour recevoir un lien de réinitialisation
            </CardDescription>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="text-center py-4 space-y-4">
                <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-500" />
                <p className="text-slate-700">
                  Si un compte existe avec ce courriel, vous recevrez un lien de réinitialisation.
                </p>
                <p className="text-sm text-slate-500">
                  Vérifiez votre boîte de réception et vos courriels indésirables.
                </p>
                <Link to="/login">
                  <Button variant="outline" className="mt-2">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Retour à la connexion
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Courriel</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@courriel.com"
                    required
                  />
                </div>

                {error && (
                  <div className="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200">
                    <AlertCircle className="w-4 h-4 text-red-500 flex-shrink-0" />
                    <p className="text-sm text-red-700">{error}</p>
                  </div>
                )}

                <Button type="submit" className="w-full" disabled={loading}>
                  {loading ? (
                    "Envoi en cours..."
                  ) : (
                    <>
                      <Mail className="w-4 h-4 mr-2" />
                      Envoyer le lien
                    </>
                  )}
                </Button>

                <div className="text-center">
                  <Link
                    to="/login"
                    className="text-sm text-indigo-600 hover:text-indigo-800 underline"
                  >
                    Retour à la connexion
                  </Link>
                </div>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
